import posthog from 'posthog-js';
import { env } from '../../env';
import { redactDeep } from './scrub';

const POSTHOG_KEY = env.POSTHOG_KEY;
const POSTHOG_HOST = env.POSTHOG_HOST;

let initialized = false;

export function initPostHog() {
  if (initialized || !POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: 'https://us.posthog.com',

    // ── Web + Product Analytics ──
    autocapture: true,
    capture_pageview: false,
    capture_pageleave: true,

    // ── Session Replay ──
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask]',
      recordCrossOriginIframes: false,
      collectFonts: true,
    },

    // ── Error Tracking ──
    capture_exceptions: true,
    before_send: (event) => {
      if (event?.event === '$exception' && event.properties) {
        event.properties = redactDeep(event.properties);
      }
      return event;
    },

    // ── Feature Flags ──
    advanced_disable_feature_flags: false,
    bootstrap: {},

    // ── Performance ──
    capture_performance: true,
    enable_heatmaps: true,
    capture_dead_clicks: true,

    // ── Privacy defaults ──
    respect_dnt: true,
    persistence: 'localStorage+cookie',

    // ── Misc ──
    loaded: (ph) => {
      if (env.IS_DEV) {
        ph.debug();
      }
    },
  });

  initialized = true;
}

export { posthog };
